module.exports = __webpack_public_path__ + "static/media/empty_plate.82342b08.png";